import { render } from "./AdminCmsPage.vue?vue&type=template&id=1c281a4e"
import script from "./AdminCmsPage.vue?vue&type=script&lang=js"
export * from "./AdminCmsPage.vue?vue&type=script&lang=js"

import "./AdminCmsPage.vue?vue&type=style&index=0&id=1c281a4e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__